import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-file-done-icon',
  templateUrl: './files-file-done.component.html'
})
export class FilesFileDoneComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
